import React, { ForwardedRef, useContext } from 'react';
import { CourseOptionFilterType } from '../../constants';
import { StyledMenu, StyledMenuItem } from '../../styledComponents';
import { CourseOptionDisplayModuleContext } from '../../context';
import { CourseOptionFilter } from '../../types';

export type MenuProps = {
  items: CourseOptionFilter[];
  filterKey: CourseOptionFilterType;
  open: boolean;
  onClose: () => void;
};

export const Menu = React.forwardRef(
  ({ open, filterKey, onClose, items }: MenuProps, ref: ForwardedRef<any>) => {
    const { selectedFilters, handleFilterChange } = useContext(
      CourseOptionDisplayModuleContext,
    );
    const selectedFilterOption = selectedFilters[filterKey];

    return (
      <StyledMenu open={open} ref={ref}>
        {items.map(({ value, label }, index) => {
          const handleClick = () => {
            handleFilterChange(value, filterKey);
            onClose();
          };

          return (
            <StyledMenuItem
              key={index}
              selected={value === selectedFilterOption}
              label={label}
              onClick={handleClick}
            />
          );
        })}
      </StyledMenu>
    );
  },
);
